// Core packages
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

// Third party packages
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { MatProgressButtonOptions } from "mat-progress-buttons";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import {
  finalize
} from "rxjs/operators";

// Custom packages
import { ConfigService } from "src/app/shared/services/config.service";
import { DocumentArchivesService } from "../../document-archives.service";

/**
 * Script start
 */

@Component({
  selector: "app-contract-expire-document-item-dialog",
  templateUrl: "./contract-expire-item-dialog.component.html",
  styleUrls: ["./contract-expire-item-dialog.component.scss"]
})
export class PropertyExpireContractItemDialogComponent
  implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  lang = this.translateService.currentLang || this.translateService.defaultLang;
  dialogIsLoading = true; // Used to view/hide form loading spinner

  // BEGIN - Edit item form
  // BEGIN - ngx-formly
  form: FormGroup = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  // END - ngx-formly
  formBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.confirm"),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "primary",
    spinnerColor: "primary",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-save",
      inline: true
    }
  };
  // END - Edit item form

  barCode = "";
  docs: any[] = [];
  selectedDocs: string[] = [];

  /**
   * Class constructor
   */
  constructor(
    public dialogRef: MatDialogRef<PropertyExpireContractItemDialogComponent>,
    public cancelContractDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private configService: ConfigService,
    private translateService: TranslateService,
    private cookieService: CookieService,
    private toastrService: ToastrService,
    private documentArchivesService: DocumentArchivesService,
  ) { }

  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
// Get current lang
    this.lang =
      this.cookieService.get("lang") || this.configService.defaultLang;

    this.documentArchivesService
      .getDocsByBarcode(this.data.documentArchiveId, this.data.barCode)
      .subscribe((res) => {
        if (res.status) {
          if (res.data && Array.isArray(res.data)) {
            res.data.forEach((item: any) => {
              this.docs.push({
                _id: item._id,
                docTitle: item.docTitle,
                structureObjectName: item.structureObjectName,
                checked: false
              })
            });
          }
        } else {
          this.toastrService.error(res.message);
        }
        this.dialogIsLoading = false;
      });

    this.barCode = this.data.barCode.substring(this.data.barCode.length - 7);
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   */
  onClose(data?: any): void {
    this.dialogRef.close(data);
  }

  /**
   * Update docs array with incoming element
   *
   * @since 1.0.0
   */
  onDocSelected(doc: any, checked: boolean): void {
    if (doc && checked) {
      this.selectedDocs.push(doc._id);
    } else if (doc && !checked) {
      const index = this.selectedDocs.indexOf(doc._id);
      this.selectedDocs.splice(index, 1);
    }
  }

  /**
   * Handle form submit
   *
   * @since 1.0.0
   */
  onFormSubmit(): void {
    // Prevent invalid form submit
    if (!this.selectedDocs.length) {
      this.toastrService.error(
        this.translateService.instant("common.errors.form_is_invalid")
      );
      return;
    }
    // Activate submit button loading status
    this.formBtnOptions.active = true;

    const sendData = {
      docs: this.selectedDocs,
    }
    this.subscriptions.push(
      this.documentArchivesService
        .expireContract(
          this.data.documentArchiveId,
          sendData
        )
        .pipe(finalize(() => (this.formBtnOptions.active = false)))
        .subscribe(
          res => {
            if (res.status) {
              this.toastrService.success(res.message);
              this.dialogRef.close({
                save: "success"
              });
            }
          },
          err => {
            this.toastrService.error(
              this.translateService.instant(err)
            );
          }
        )
    );
    
  }
}
